import { render, staticRenderFns } from "./detailRecords.vue?vue&type=template&id=319a43ba&scoped=true&"
import script from "./detailRecords.vue?vue&type=script&lang=js&"
export * from "./detailRecords.vue?vue&type=script&lang=js&"
import style0 from "./detailRecords.vue?vue&type=style&index=0&id=319a43ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319a43ba",
  null
  
)

export default component.exports